import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@capturi/ui-components'
import type { BaseModalComponentProps } from '@capturi/use-modal'
import { Flex, Text } from '@chakra-ui/react'
import { Trans } from '@lingui/react/macro'
import type { FC } from 'react'

type Props = BaseModalComponentProps

const AuthorizationErrorModal: FC<Props> = ({ onClose }) => {
  return (
    <Modal isOpen onClose={onClose} closeOnOverlayClick>
      <ModalOverlay>
        <ModalContent>
          <Flex direction="column">
            <ModalHeader>
              <Trans>No access to this organization</Trans>
            </ModalHeader>
          </Flex>
          <ModalCloseButton />
          <ModalBody>
            <Text>
              <Trans>
                You do not have access to this organization. You have been
                redirected to your last used organization.
              </Trans>
            </Text>
          </ModalBody>
        </ModalContent>
      </ModalOverlay>
    </Modal>
  )
}

export default AuthorizationErrorModal
